import { useState, useEffect, useLayoutEffect } from 'react'

import { postMessage, buttonImpressionMessage } from 'messenger'

const SHOP_BUTTON_URL = process.env.BASE_URL + process.env.SHOP_BUTTON_PATH

const FULL_IFRAME_THRESHOLD = 1
const ENABLE_AD_IFRAME_THRESHOLD = 0.18

export function useMediaQuery(query) {
  const mediaMatch = window.matchMedia(query)
  const [matches, setMatches] = useState(mediaMatch.matches)

  useLayoutEffect(() => {
    const handler = () => setMatches(window.matchMedia(query).matches)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [setMatches])

  return matches
}

export function useMessageEvent(listener) {
  useEffect(() => {
    window.addEventListener('message', listener)
    return () => window.removeEventListener('message', listener)
  }, [])
}

export function useImpression(refCurrent, buttonIframeElementId,  isButtonLoaded, enableCircularAd = false) {
  useEffect(() => {
    let observer
    let impressionCount = 0

    const sendImpressionEvent = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && isButtonLoaded) {
          impressionCount += 1
          const buttonsWindow = document.getElementById(buttonIframeElementId).contentWindow
          postMessage(
            buttonImpressionMessage({ count: impressionCount }),
            buttonsWindow,
            SHOP_BUTTON_URL
          )
        }
      })
    }

    if (!observer && refCurrent && isButtonLoaded) {
      const threshold = enableCircularAd ? ENABLE_AD_IFRAME_THRESHOLD : FULL_IFRAME_THRESHOLD
      observer = new IntersectionObserver(sendImpressionEvent, { threshold })
      observer.observe(refCurrent)
    }
    return () => {
      observer?.disconnect()
    }
  }, [refCurrent, isButtonLoaded])
}
